import { GiCancel } from 'react-icons/gi'

const CanceledLabel = ({ message } : { message : string }) =>
  <div className='flex items-center gap-1 text-gray-500'>
    <GiCancel color='gray' size={32}/>
    <h6>{message}</h6>
  </div>

export default CanceledLabel